<template>
	<component :is="href ? 'a' : 'span'" :href="href" class="LogosGrid-item">
		<!-- Slot for logo image -->
		<slot />
	</component>
</template>

<script>
export default {
	name: 'CloLogosGridItem',
	props: {
		href: {
			type: String,
			required: false,
		},
	},
	data() {
		return {};
	},
};
</script>
